<template>
  <div>
    <v-simple-table :dense="config.dense || false" small>
      <tbody>
        <tr v-for="(el, i) in modelC" :key="i" v-if="el.type">
          <td class="text-left" :style="`font-weight: 500; height: ${config.size || 34}px;${el.color ? 'color:' + el.color : ''}`">
            {{ el.title }}:

            <v-btn v-if="el.canCopy && (el.value || getValue(el))" icon small @click="copyToClipboard(el)" title="Скопировать">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </td>
          <td
            class="text-left px-0"
            :style="`height: ${config.size || 38}px;${el.color ? 'color:' + el.color : ''}`"
            @click="$emit('click', { event: $event, field: el, row: data })"
          >
            <div class="d-flex align-center">
              <component
                v-if="el.type"
                :is="'a-view-' + el.type"
                :model="el"
                :values="data"
                :value="el.value || getValue(el)"
                @onEdit="$emit('onEdit', { field: el.name, value: $event })"
              />
              <template v-if="buttons(el) && (el.value || getValue(el))">
                <v-btn
                  v-for="(btn, k) in buttons(el)"
                  :key="k"
                  :icon="btn.type == 'icon'"
                  :small="btn.size == 'small'"
                  :x-small="btn.size == 'x-small'"
                  @click.native.stop="onActionClick(el, btn)"
                  :title="btn.title"
                  class="ml-1"
                >
                  <v-icon :small="btn.size == 'small'" :x-small="btn.size == 'x-small'">{{ btn.icon }}</v-icon>
                </v-btn>
              </template>
            </div>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    model: Array,
    config: {
      type: Object,
      default: () => {
        return { dense: false, hideDetails: false, hideNull: false };
      },
    },
  },
  data() {
    return {
      mode: "view",
      m: [],
    };
  },
  computed: {
    data: {
      get() {
        return this.value;
      },
    },
    modelC() {
      let m = [];
      if (this.model) {
        m = JSON.parse(JSON.stringify(this.model));
        m = m.filter((el) => {
          return el?.type;
          return (el?.type || false) && el?.hidden !== true;
          //многие поля в моделе скрыты для формы, но здесь должны отобажаться
        });
        m.forEach((el) => {
          if (el.type && (el.type == "comboboxapi" || el.type == "stringmask")) {
            el.type = "string";
          }
          if (el.type && el.type == "datetimestring") {
            el.type = "datetime";
          }
          if (el.type && el.type == "datestring") {
            el.type = "date";
          } 
          if (el.type && el.type == "inn") {
            el.type = "string";
          }
          if (this.config.hideNull && !el?.showNull)
            if (!this.getValue(el) && !this.data[el.name]) {
              el.hide = true;
            }
          if (el?.apiVar) {
            //устанавливаю значение title
            const key = el.apiVar.key;
            if (this.value) {
              const v = el?.json ? this.value?.data?.[key] : this.value[key];
              const name = el.apiVar.apiName.find((el) => {
                return el.value == v;
              });
              el.title = name?.title || el.title || null;
            }
          }
          if (el?.dirVar) {
            //устанавливаю значение title
            const key = el.dirVar.key;
            if (this.value) {
              const v = el?.json ? this.value?.data?.[key] : this.value[key];
              const name = el.dirVar.dirName.find((el) => {
                return el.value == v;
              });
              el.title = name?.title || el.title || null;
            }
          }
        });
      }

      m = m.filter((el) => {
        return !el?.hide && !el.hidden;
      });
      return m;
    },
  },
  created() {},
  watch: {},
  methods: {
    onActionClick(el, btn) {
      if (btn.action == "route") {
        //console.log("actionClick", btn.action, el, this.getValue(el));

        let routeData = this.$router.resolve({ name: btn.route.name, params: { id: el.value || this.getValue(el, btn?.fieldValue) } });
        //console.log("open", routeData);
        return window.open(routeData.href, "_blank");
        return;
      }
      this.$emit("actionClick", { name: el.name, value: el.value || this.getValue(el), button: btn });
    },
    buttons(el) {
      if (el.iconAction) {
        return [{ name: "copy", title: "Скопировать", action: "copy", icon: el.iconAction, type: "icon" }];
      }
      if (el.buttons && this.$root.profile.role >= 30) {
        let buttons = [];
        el.buttons.forEach((btn) => {
          if (btn.rules) {
            if (btn.rules?.formula) {
              let rule = eval(btn.rules.formula);
              if (rule && rule(this.data)) {
                buttons.push(btn);
              }
            }
          } else buttons.push(btn);
        });
        return buttons;
      }

      return false;
    },
    copyToClipboard(el) {
      let v = el.value || this.getValue(el);
      if (el.type == "phone" && !(v || "").startsWith("+")) v = "+" + v;
      navigator.clipboard
        .writeText(v)
        .then(() => {
          this.$root.$emit("show-info", { color: "blue", text: "Скопировано..." });
        })
        .catch((err) => {
          this.$root.$emit("show-info", { type: "error", text: "Ошибка...." });
          console.error("Ошибка при копировании: ", err);
        });
    },
    getValue(el, name = "") {
      if (el.value) return el.value;
      if (!name) name = el.name;
      let res = Object.assign({}, this.data);
      //let res = this.data;
      name.split(".").forEach((n) => {
        if (res) {
          res = res?.[n];
        }
      });
      return res;
    },
  },
};
</script>
